import React from 'react';
import {ChevronDownIcon, EyeIcon, EyeSlashIcon} from '@heroicons/react/24/outline';
import {useLayer} from '@craftjs/layers';
import {useEditor} from '@craftjs/core';
import {classNames} from 'utils';

import EditorLayersName from './Editor.Layers.Name';
import iconLookUp from './iconLookup';

interface IEditorLayersHeaderProps {}

const EditorLayersHeader = ({}: IEditorLayersHeaderProps) => {
  const {
    id,
    depth,
    expanded,
    children,
    connectors: {drag, layerHeader},
    actions: {toggleLayer},
  } = useLayer(layer => {
    return {
      expanded: layer.expanded,
    };
  });

  const {hidden, icon, actions, selected} = useEditor((state, query) => {
    const selected = query.getEvent('selected').first() === id;
    return {
      hidden: state.nodes[id] && state.nodes[id].data.hidden,
      icon: state.nodes[id] && state.nodes[id].data.custom.icon,
      selected,
    };
  });

  return (
    <div
      ref={dom => {
        dom && drag(dom);
      }}
      className={classNames(
        'flex items-center rounded-sm py-1 px-1.5',
        selected ? 'bg-primary text-white cursor-text' : 'cursor-pointer',
        hidden && 'opacity-50',
      )}
      style={{marginLeft: `${depth * 10}px`}}>
      <button type="button" className={classNames('cursor-pointer mr-2', selected && 'text-white')} onClick={() => actions.setHidden(id, !hidden)}>
        {hidden ? <EyeSlashIcon className="size-5" /> : <EyeIcon className="size-5" />}
      </button>
      <div className="w-full overflow-hidden">
        <div
          ref={dom => {
            dom && layerHeader(dom);
          }}
          className="flex items-center justify-between w-full gap-1.5">
          {(() => {
            const Icon = iconLookUp[icon];
            return Icon ? <Icon className="size-4 mr-1" /> : null;
          })()}
          <EditorLayersName selected={selected} />
          {children && children.length ? (
            <button
              type="button"
              className={classNames('expand-toggle', 'transition cursor-pointer', expanded ? 'rotate-180' : 'rotate-0')}
              onClick={toggleLayer}>
              <ChevronDownIcon className="size-5" />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default React.memo(EditorLayersHeader);
